import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import Rankings from "@/pages/rankings/page";
import Moments from "@/pages/moments/page";
import TopicDetail from "@/pages/topic/page";
import About from "@/pages/about/page";
import Faq from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/rankings",
    element: <Rankings />,
  },
  {
    path: "/moments",
    element: <Moments />,
  },
  {
    path: "/topic/:slug",
    element: <TopicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/faq",
    element: <Faq />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;